import React, { useState } from 'react';
import { LogOut, User, ChevronDown, Menu } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import UserAvatar from './UserAvatar';
import GlobalSearch from './GlobalSearch';
import './Header.css';

const Header = ({ operationLoading, currentPage, onPageChange, onMenuToggle, onProfileClick, searchTerm, onSearchChange }) => {
  const { user, signOut } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);

  const handleLogout = async () => {
    setLoggingOut(true);
    try {
      await signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    } finally {
      setLoggingOut(false);
      setShowUserMenu(false);
    }
  };

  const handleProfileClick = () => {
    setShowUserMenu(false);
    if (onProfileClick) {
      onProfileClick();
    }
  };

  const toggleUserMenu = () => {
    setShowUserMenu(!showUserMenu);
  };

  const getUserDisplayName = () => {
    if (user?.user_metadata?.full_name) {
      return user.user_metadata.full_name;
    }
    if (user?.email) {
      return user.email.split('@')[0];
    }
    return 'User';
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left">
          <button className="sidebar-toggle" onClick={onMenuToggle}>
            <Menu size={20} />
          </button>
        </div>
        
        <div className="header-search">
          <GlobalSearch />
        </div>
        
        <div className="header-right">
          <div className="user-menu">
            <button
              onClick={toggleUserMenu}
              className="user-menu-trigger"
              disabled={loggingOut}
            >
              <UserAvatar user={user} size="small" />
              <div className="user-info">
                <span className="user-name">{getUserDisplayName()}</span>
                <span className="user-email">{user?.email}</span>
              </div>
              <ChevronDown 
                size={16} 
                className={`chevron ${showUserMenu ? 'rotated' : ''}`} 
              />
            </button>

            {showUserMenu && (
              <div className="user-dropdown">
                <div className="user-dropdown-header">
                  <UserAvatar user={user} size="medium" />
                  <div>
                    <div className="user-name-large">{getUserDisplayName()}</div>
                    <div className="user-email-small">{user?.email}</div>
                  </div>
                </div>
                
                <div className="dropdown-divider"></div>
                
                <button
                  onClick={handleProfileClick}
                  className="dropdown-item"
                >
                  <User size={16} />
                  Profile
                </button>
                
                <button
                  onClick={handleLogout}
                  className="dropdown-item logout-btn"
                  disabled={loggingOut}
                >
                  <LogOut size={16} />
                  {loggingOut ? 'Signing out...' : 'Sign Out'}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {showUserMenu && (
        <div 
          className="user-menu-overlay" 
          onClick={() => setShowUserMenu(false)}
        />
      )}
    </header>
  );
};

export default Header;